/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const designTokensDemoContent = [
  { type: 'heading', level: 1, text: 'Design tokens audit' },
  { type: 'heading', level: 2, text: 'Spacing' },
  {
    type: 'bullets',
    items: [
      'Align rail padding with briefing cards (8px inset)',
      'Use 18px outer radius on meeting cards',
    ],
  },
  { type: 'heading', level: 2, text: 'Typography' },
  {
    type: 'bullets',
    items: [
      'Section titles: 590 weight, −0.2px tracking',
      'Body: 400 weight, 24px line height',
    ],
  },
  {
    type: 'checklist',
    items: [
      { text: 'Document tokens in Storybook', checked: false },
      { text: 'Sync Pampas surfaces with briefing', checked: true },
    ],
  },
]
